/* eslint-disable max-len, no-trailing-spaces */
import CmsContent from 'components/CmsContent';
import React from 'react';

export default function Privacy() {
  return <CmsContent pageName="privacy" />;
}

Privacy.displayName = 'Privacy';
